const pagesCardData = [
    {
        label: 'About Us',
        image: require('../../assets/images/page-icon/about-us.png'),
    },
    {
        label: 'FAQs',
        image: require('../../assets/images/page-icon/faq.png'),
    },
    {
        label: 'Services',
        image: require('../../assets/images/page-icon/services.png'),
    },
    {
        label: 'Blog',
        image: require('../../assets/images/page-icon/blog.png'),
    },
    {
        label: 'Media Gallery',
        image: require('../../assets/images/page-icon/gallery.png'),
    },
    {
        label: 'Projects',
        image: require('../../assets/images/page-icon/projects.png'),
    },
    {
        label: 'Testimonials',
        image: require('../../assets/images/page-icon/testimonials.png'),
    },
    {
        label: 'Terms of Service',
        image: require('../../assets/images/page-icon/tos.png'),
    },
    {
        label: 'Social Media',
        image: require('../../assets/images/page-icon/social-media.png'),
    },
    {
        label: 'Analytics Dashboard',
        image: require('../../assets/images/page-icon/dashboard.png'),
    },
    {
        label: 'Booking',
        image: require('../../assets/images/page-icon/booking.png'),
    },
    {
        label: 'Calendar',
        image: require('../../assets/images/page-icon/calendar.png'),
    },
    {
        label: 'Chat',
        image: require('../../assets/images/page-icon/chat.png'),
    },
    {
        label: 'Map',
        image: require('../../assets/images/page-icon/map.png'),
    },
    {
        label: 'Membership',
        image: require('../../assets/images/page-icon/membership.png'),
    },
    {
        label: 'Payment Process',
        image: require('../../assets/images/page-icon/payment.png'),
    },
    {
        label: 'Policy',
        image: require('../../assets/images/page-icon/tos.png'),
    },
    {
        label: 'Contact',
        image: require('../../assets/images/page-icon/payment.png'),
    },
];

export default pagesCardData;